import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import i18next from "i18next";

import EntityDetail from "./entity_detail";
import { EntityService } from '../../services';
import config from "config";

const EntityDetailModal = ({isMobile, entitySerialNumber, entity, show, onHide, onError}) => {
  const [displayEntity, setDisplayEntity] = useState(entity);

  useEffect(() => {
    if (entitySerialNumber) {
      setDisplayEntity(null);

      EntityService.getBySerialNumber(entitySerialNumber)
      .then(({entity}) => setDisplayEntity(entity))
      .catch((error) => {
        console.error(error);
        onError(error);
      });
    }
  }, [entitySerialNumber]);

  return (
    <Modal className={isMobile ? "modal-device-detail-mobile" : "modal-device-detail"} show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {
            displayEntity != null && 
            <div>
              {displayEntity.displayName}
              <div className = "modal-subheader">
                <img src={`${config.WEB_BASE_URL}/images/icon/line_category.svg`} className="icon icon--small" />
                {displayEntity.entityTypeName}
              </div>
            </div>
        }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          displayEntity != null ? <EntityDetail isMobile={isMobile} entity={displayEntity} /> : <div className="loader">{ i18next.t('loading') }</div>
        }
      </Modal.Body>
    </Modal>
  );
};

EntityDetailModal.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    entity: PropTypes.object,
    entityId: PropTypes.number,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onError: PropTypes.func
};

export default EntityDetailModal;